import React, { Component } from 'react';

import {Carousel} from 'react-responsive-carousel'
// import 'react-responsive-carousel/lib/styles/carousel.css'
import './carousel.css'
import './slider.css'

// import five from  '../img/5-star-reviews.png'
// import averageRatingImg from  '../img/average-rating.png'
import reviews from './reviews'


const Review = ({review}) => {
	return (
		<div>
			<div className="box">
				<article className="media">
					<figure className="media-left">
						<p className="image is-64x64 is-rounded">
							<img src={review.avatar} alt=""/>
						</p>
					</figure>
					<div className="media-content">
						<div className="content">
							<p>{review.text}</p>
							<p>
								<i className="fal fa-user"></i>
								<span className="space10"></span>
								<strong>{review.name}</strong> <small>{review.date}</small>
							</p>
						</div>
					</div>
				</article>
			</div>
		</div>
	)
}


/*
Parse reviews at https://www.codementor.io/yurio/reviews
var img = $0.querySelector('.avatar-img__img-avatar').style["backgroundImage"].match(/\"(.*)\"/)[1];
var text = $0.querySelector('.user-profile__reviews__review-content').innerText;
var name = $0.querySelector('.user-profile__reviews__reviewer-name').innerText;
var date = $0.querySelector('.user-profile__reviews__review-date').innerText;
var o = { avatar:img, text, name, date };
JSON.stringify(o);
*/


class App extends Component {


	render() {
		return (
			<section className="hero is-light">
				<div className="hero-body">
					<div className="container">

					<div className="columns">
						<div className="column feature">
							<h2 className="title">Over 1000</h2>
							<h3 className="subtitle">happy reviews</h3>
						</div>
						<div className="column feature">
							<h2 className="title">Over 2500</h2>
							<h3 className="subtitle">sessions</h3>
						</div>
						<div className="column feature">
							<h2 className="title">Over 15 years</h2>
							<h3 className="subtitle">in web development</h3>
						</div>
					</div>

					{/* http://react-responsive-carousel.js.org/storybook/*/}
					<Carousel
						showArrows={true}
						showThumbs={false}
						showStatus={false}
						showIndicators={false}
						autoPlay
						interval={4000} 
						infiniteLoop
						>

						{reviews.map( (review,i) => <Review key={i} review={review} /> )}
					</Carousel>
				

					</div> 
				</div>
			</section>

		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/Slider/Slider.js